// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JQAW","title":"Header_title__35PtH","side":"Header_side__3a4lQ"};